import Index from "../components/privacy/Index.vue"
import init from "../root_init"
init(Index)
